import { AssignmentStage } from 'constants/assignment'
import { VisualFileType } from 'constants/visual'

/** The name before its first dot, the stem the backend compares names by. */
const stem = (filename: string) => filename.split('.')[0]

/** Whether an admin may remove the selected visuals: delivered visuals of a not cancelled assignment, viewed on the delivered (POST) tab. */
export const canRemoveDeliveredVisuals = (
  stage: AssignmentStage | undefined,
  isCancelled: boolean,
  visualType: string,
  selectedCount: number
): boolean => stage === AssignmentStage.VISUALS_SENT_TO_CLIENT && !isCancelled && visualType === VisualFileType.POST && selectedCount > 0

/** Whether the client purchased [filename], comparing names without extension as the backend does. */
export const isPurchasedVisual = (filename: string, purchasedFilenames: ReadonlySet<string>): boolean => {
  const target = stem(filename)
  return Array.from(purchasedFilenames).some(purchased => stem(purchased) === target)
}
